import { axiosInstance } from "./";

const getReportList = async ({ id, params }) => {
  return await axiosInstance.get(`/events/${id}/logistics_issues`, { params });
};
const getReportDetail = async ({ event_id, id }) =>
  await axiosInstance.get(`/events/${event_id}/logistics_issues/${id}`);

const createReport = async ({ id, data }) =>
  await axiosInstance.post(`/events/${id}/logistics_issues`, data);

const updateReport = async ({ event_id, id, data }) =>
  await axiosInstance.patch(
    `/events/${event_id}/logistics_issues/${id}`,
    data,
  );

/** GET /admin_portal/v2/logistics_issues/{id}/logistics_issue_comments */
const getReportComments = async ({ id, params } = {}) =>
  await axiosInstance.get(`/logistics_issues/${id}/logistics_issue_comments`, {
    params,
  });

/** POST /admin_portal/v2/logistics_issues/{id}/logistics_issue_comments */
const createReportComment = async ({ id, data }) =>
  await axiosInstance.post(
    `/logistics_issues/${id}/logistics_issue_comments`,
    data,
  );

/** GET /admin_portal/v2/events/{event_id}/logistics_issues/export_to_xls */
const exportReportSheet = async ({ id, params }) =>
  await axiosInstance.get(`/events/${id}/logistics_issues/export_to_xls`, {
    params,
    responseType: "blob",
  });

export {
  getReportList,
  getReportDetail,
  createReport,
  updateReport,
  getReportComments,
  createReportComment,
  exportReportSheet,
};
